import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { useRecoilState, useRecoilValue } from "recoil";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ConfirmInfo } from './parts/ConfirmInfo';
import { FormCource } from './form/FormCource';
import { FormCourceItem } from './form/FormCourceItem';
import { FormCourceJunkai } from './form/FormCourceJunkai';
import { FormClinic } from './form/FormClinic';
import { FormVenue } from './form/FormVenue';
import { FormOption } from './form/FormOption';
import { FormrRequestDate } from './form/FormrRequestDate';
import { FormExamDate } from './form/FormExamDate';
import { FormrNote } from './form/FormrNote';
import { FormCalendar } from './form/FormCalendar';
import { FormVenueItemList } from './form/FormVenueItemList';
import { SeikenClinicInfo } from './parts/SeikenClinicInfo';
import { PrevPageButton } from './parts/PrevPageButton';
import { SubmitButton } from './parts/SubmitButton';

import { confirmState } from '../../store/confirmState';
import { orderState } from '../../store/orderState';
import { userState } from '../../store/userState';
import { companyState } from '../../store/companyState';
import { isSurveyState } from '../../store/isSurveyState';
import { simulationAmountState } from '../../store/simulationAmountState';

export const ProxyCheckupNew = memo((props) => {
  const { cm, user, staff_user, page_title, cources, seiken_cources, junkai_cources } = props;
  const [pageAction, setPageAction] = useState('new');
  const [isDisabled, setIsDisabled] = useState(true);
  const [isConfirm, setIsConfirm] = useRecoilState(confirmState);
  const [orderData, setOrderData] = useRecoilState(orderState);
  const [userData, setUserData] = useRecoilState(userState);
  const [cmData, setCmData] = useRecoilState(companyState);
  const isSurvayData = useRecoilValue(isSurveyState);
  const [simulationAmountData, setSimulationAmountData] = useRecoilState(simulationAmountState);

  const initialSimulationAmountData = {
    loading: false,
    cource_type: null,
    funding_price: '',
    calc_price: '',
    result_price: '',
    message: '',
  }

  // 初期設定データセット
  useEffect(() => {
    setUserData({user_id: user});
    setCmData({company_id: cm});
  }, []);

  // CourceCode[1..79][110..119] 医療機関選択・自己手配計算処理
  const getSimulationAmount = async (data) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.get(`/api/v1/calculations`, data)
                .then(resp => {
                  console.log("get SimulationAmount success");
                  // console.log(resp.data);
                  setSimulationAmountData(resp.data.simulation_amount);
                })
                .catch(e => {
                  console.log("SimulationAmount error");
                  // console.log(e.response);
                });
    return res;
  }

  // CourceCode[120..149] 生研用計算処理
  const getSimulationAmountWithSeiken = async (data) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.get(`/api/v1/seiken_calculations`, data)
                .then(resp => {
                  console.log("get Seiken SimulationAmount success");
                  // console.log(resp.data);
                  setSimulationAmountData(resp.data.simulation_amount);
                })
                .catch(e => {
                  console.log("Seiken SimulationAmount error");
                  // console.log(e.response);
                });
    return res;
  }

  // 確認画面から前のページに戻る
  const onChangePrevPage = () => {
    window.scrollTo(0, 0);
    setSimulationAmountData(initialSimulationAmountData);
    setIsConfirm(false);
  }

  // CourceCode[80..99]巡回 計算処理無し確認画面
  const onClickConfirm = () => {
    window.scrollTo(0, 0);
    setSimulationAmountData({...simulationAmountData, loading: true});
    setIsConfirm(true);
  }

  // CourceCode[1..79][110..119] 確認画面
  const onClickConfirmWithCal = () => {
    window.scrollTo(0, 0);
    setIsConfirm(true);

    var data = { params: {
      cource_id: orderData.cource_id,
      clinic_id: orderData.requestclinic_id,
      options: orderData.options,
    }};
    getSimulationAmount(data);
  }

  // Cource[120..149] 生研用確認画面
  const onClickConfirmWithSeikenCal = () => {
    window.scrollTo(0, 0);
    setIsConfirm(true);

    var data = { params: {
      cource_id: orderData.cource_id,
      options: orderData.options,
    }};
    getSimulationAmountWithSeiken(data);
  }

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true,
      });
    } else {
      toast.error(message, {
        hideProgressBar: false,
      });
    }
  }

  // ClinicCource[1..79] 送信
  const onSubmitOrder = (e) => {
    setIsDisabled(false);
    var data = {
      proxy_checkup: {
        mtemployee_id: userData.user_id,
        staff_users_id: staff_user,
        status: 'order_init',
        cource_id: orderData.cource_id,
        cource_code: orderData.cource_code,
        requestcource: orderData.requestcource,
        requestpref_code: orderData.requestpref_code,
        requestclinic_id: orderData.requestclinic_id,
        requestclinic: orderData.requestclinic,
        dtpendingorder_options_attributes: orderData.options,
        requestdt1: orderData.requestdt1,
        requestdt1_ampm: orderData.requestdt1_ampm,
        requestdt2: orderData.requestdt2,
        requestdt2_ampm: orderData.requestdt2_ampm,
        requestdt3: orderData.requestdt3,
        requestdt3_ampm: orderData.requestdt3_ampm,
        requestnote: orderData.requestnote,
        calc_price: simulationAmountData.calc_price,
        result_price: simulationAmountData.result_price,
      },
      mtemployee_id: userData.user_id,
    };

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/proxy_checkup`, data)
    .then(resp => {
      console.log("ProxyOrder api ok");
      console.log(resp.data);
      notify("success", "ProxyOrder Create Success!");
      window.location.href = `/agent/proxy_checkup?mtemployee_id=${userData.user_id}`;
    })
    .catch(e => {
      console.log("ProxyOrder api ng");
      console.log(e.response);
      window.scrollTo(0, 0);
      setIsConfirm(!isConfirm);
      notify("error", "ProxyOrder Create Error!");
      setIsDisabled(true);
    });
  }

  // JunkaiForm(CourceVenueItem)[80..99] 送信
  const onSubmitJunkaiOrder = (e) => {
    setIsDisabled(false);
    if (isSurvayData.is_survey) {
      var data = { 
        proxy_checkup: {
          mtemployee_id: userData.user_id,
          staff_users_id: staff_user,
          status: 'order_commited',
          cource_id: orderData.cource_id,
          cource_code: orderData.cource_code,
          requestcource: orderData.requestcource,
          requestpref_code: orderData.requestpref_code,
          examclinic: orderData.requestclinic,
          examvenue_id: orderData.requestclinic_id,
          is_survey: isSurvayData.is_survey,
        },
        mtemployee_id: userData.user_id,
      };
    } else {
      var data = { 
        proxy_checkup: {
          mtemployee_id: userData.user_id,
          staff_users_id: staff_user,
          status: 'order_commited',
          cource_id: orderData.cource_id,
          cource_code: orderData.cource_code,
          requestcource: orderData.requestcource,
          requestpref_code: orderData.requestpref_code,
          examclinic: orderData.requestclinic,
          examvenue_id: orderData.requestclinic_id,
          examdt: orderData.examdt,
          item_id: orderData.item_id,
          is_survey: isSurvayData.is_survey,
        },
        mtemployee_id: userData.user_id,
      };
    }

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/proxy_checkup`, data)
    .then(resp => {
      console.log("Proxy CourceVenueItem api ok");
      console.log(resp.data);
      notify("success", "Proxy CourceVenueItem Create Success!");
      window.location.href = `/agent/proxy_checkup?mtemployee_id=${userData.user_id}`;
    })
    .catch(e => {
      console.log("Proxy CourceVenueItem api ng");
      console.log(e.response);
      window.scrollTo(0, 0);
      setIsConfirm(!isConfirm);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Proxy CourceVenueItem Create Error!");
      setIsDisabled(true);
    });
  }

  // JigoCource[110..119] 送信
  const onSubmitJigoOrder = (e) => {
    setIsDisabled(false);
    var data = { 
      proxy_checkup: {
        mtemployee_id: userData.user_id,
        staff_users_id: staff_user,
        status: 'order_commited',
        cource_id: orderData.cource_id,
        cource_code: orderData.cource_code,
        requestcource: orderData.requestcource,
        requestpref_code: orderData.requestpref_code,
        requestclinic_id: orderData.requestclinic_id,
        requestclinic: orderData.requestclinic,
        dtpendingorder_options_attributes: orderData.options,
        examclinic_id: orderData.requestclinic_id,
        examclinic: orderData.requestclinic,
        examdt: `${orderData.examdt} ${orderData.examdtime}`,
        requestnote: orderData.requestnote,
        calc_price: simulationAmountData.calc_price,
        result_price: simulationAmountData.result_price,
      },
      mtemployee_id: userData.user_id,
    };

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/proxy_checkup`, data)
    .then(resp => {
      console.log("Proxy JigoCource api ok");
      console.log(resp.data);
      notify("success", "Proxy JigoCource Create Success!");
      window.location.href = `/agent/proxy_checkup?mtemployee_id=${userData.user_id}`;
    })
    .catch(e => {
      console.log("Proxy JigoCource api ng");
      console.log(e.response);
      window.scrollTo(0, 0);
      setIsConfirm(!isConfirm);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Proxy JigoCource Create Error!");
      setIsDisabled(true);
    });
  }

  // SeikenForm(CourceItem)[120..149] 送信
  const onSubmitSeikenOrder = (e) => {
    setIsDisabled(false);
    var data = { 
      proxy_checkup: {
        mtemployee_id: userData.user_id,
        staff_users_id: staff_user,
        status: 'order_commited',
        cource_id: orderData.cource_id,
        cource_code: orderData.cource_code,
        requestcource: orderData.requestcource,
        examclinic: '朝日生命成人病研究所附属医院',
        examdt: orderData.examdt,
        item_id: orderData.item_id,
        dtpendingorder_options_attributes: orderData.options,
        requestnote: orderData.requestnote,
        calc_price: simulationAmountData.calc_price,
        result_price: simulationAmountData.result_price,
      },
      mtemployee_id: userData.user_id,
    };

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/proxy_checkup`, data)
    .then(resp => {
      console.log("Proxy CourceItem api ok");
      console.log(resp.data);
      notify("success", "Proxy CourceItem Create Success!");
      window.location.href = `/agent/proxy_checkup?mtemployee_id=${userData.user_id}`;
    })
    .catch(e => {
      console.log("Proxy CourceItem api ng");
      console.log(e.response);
      window.scrollTo(0, 0);
      setIsConfirm(!isConfirm);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Proxy CourceItem Create Error!");
      setIsDisabled(true);
    });
  }

  const submitBtnDisplay = (txt, isOnlick) => {
    return (
      <Fragment>
        {isSurvayData.is_survey ?
          <SubmitButton
            text={txt}
            onClick={isOnlick}
            isDisabledVal={
              isDisabled
              && orderData.cource_id
              && orderData.cource_code
              && orderData.requestcource
              && orderData.requestpref_code
              && orderData.requestclinic
              && orderData.requestclinic_id ? false : true
            }
          />
        :
          <SubmitButton
            text={txt}
            onClick={isOnlick}
            isDisabledVal={
              isDisabled
              && orderData.cource_id
              && orderData.cource_code
              && orderData.requestcource
              && orderData.requestpref_code
              && orderData.requestclinic
              && orderData.requestclinic_id
              && orderData.examdt
              && orderData.item_id ? false : true
            }
          />
        }
      </Fragment>
    )
  }

  const SwitchFormDisplay = () => {
    if (80 <= parseInt(orderData.cource_code, 10) && parseInt(orderData.cource_code, 10) < 99) {
      // JunkaiCourceForm [80..99]
      return (
        <Fragment>
          {seiken_cources.length > 0 && <FormCourceItem seiken_cources={seiken_cources} />}
          {junkai_cources.length > 0 && <FormCourceJunkai junkai_cources={junkai_cources} />}
          <FormCource cources={cources} />
          <FormVenue isConfirm={isConfirm} />
          <FormVenueItemList isConfirm={isConfirm} />
          { isConfirm ?
            <Fragment>
              <PrevPageButton text="内容の修正" onClick={onChangePrevPage} />
              {submitBtnDisplay("巡回の予約申し込み", onSubmitJunkaiOrder)}
            </Fragment>
          :
            <Fragment>
              {submitBtnDisplay("巡回の確認画面へ", onClickConfirm)}
            </Fragment>
          }
        </Fragment>
      )
    } else if (110 <= parseInt(orderData.cource_code, 10) && parseInt(orderData.cource_code, 10) < 119) {
      // JigoCourceForm [110..119]
      return (
        <Fragment>
          {seiken_cources.length > 0 && <FormCourceItem seiken_cources={seiken_cources} />}
          {junkai_cources.length > 0 && <FormCourceJunkai junkai_cources={junkai_cources} />}
          <FormCource cources={cources} />
          <FormClinic />
          <FormOption />
          <FormExamDate />
          <FormrNote />
          { isConfirm ?
            <Fragment>
              <PrevPageButton text="内容の修正" onClick={onChangePrevPage} />
              <SubmitButton
                text="自己手配報告する"
                onClick={onSubmitJigoOrder}
                isDisabledVal={
                  isDisabled
                  && simulationAmountData.loading
                  && orderData.cource_id
                  && orderData.cource_code
                  && orderData.requestcource
                  && orderData.requestpref_code
                  && orderData.requestclinic_id
                  && orderData.requestclinic
                  && orderData.examdt
                  && orderData.examdtime ? false : true
                }
              />
            </Fragment>
          :
            <SubmitButton 
              text="自己手配報告の確認画面へ"
              onClick={onClickConfirmWithCal}
              isDisabledVal={
                isDisabled
                && orderData.cource_id
                && orderData.cource_code
                && orderData.requestcource
                && orderData.requestpref_code
                && orderData.requestclinic_id
                && orderData.requestclinic
                && orderData.examdt
                && orderData.examdtime ? false : true
              }
            />
          }
        </Fragment>
      )
    } else if (120 <= parseInt(orderData.cource_code, 10) && parseInt(orderData.cource_code, 10) < 149) {
      // SeikenForm(CourceItem) [120..149]
      return (
        <Fragment>
          {seiken_cources.length > 0 && <FormCourceItem seiken_cources={seiken_cources} />}
          {junkai_cources.length > 0 && <FormCourceJunkai junkai_cources={junkai_cources} />}
          <FormCource cources={cources} />
          <SeikenClinicInfo />
          <FormCalendar />
          <FormOption />
          <FormrNote />
          { isConfirm ?
            <Fragment>
              <PrevPageButton text="内容の修正" onClick={onChangePrevPage} />
              <SubmitButton
                text="生研の予約申し込み"
                onClick={onSubmitSeikenOrder}
                isDisabledVal={
                  isDisabled
                  && simulationAmountData.loading
                  && orderData.cource_id
                  && orderData.cource_code
                  && orderData.requestcource
                  && orderData.examdt
                  && orderData.item_id ? false : true
                }
              />
            </Fragment>
          :
            <SubmitButton 
              text="生研の確認画面へ"
              onClick={onClickConfirmWithSeikenCal}
              isDisabledVal={
                isDisabled
                && orderData.cource_id
                && orderData.cource_code
                && orderData.requestcource
                && orderData.examdt
                && orderData.item_id ? false : true
              }
            />
          }
        </Fragment>
      )
    } else {
      // DefaultForm [1..79]
      return (
        <Fragment>
          {seiken_cources.length > 0 && <FormCourceItem seiken_cources={seiken_cources} />}
          {junkai_cources.length > 0 && <FormCourceJunkai junkai_cources={junkai_cources} />}
          <FormCource cources={cources} />
          <FormClinic />
          <FormOption />
          <FormrRequestDate />
          <FormrNote />
          { isConfirm ?
            <Fragment>
              <button type="submit" name="testName" value="testValue" className="btn btn-outline-secondary btn-lg w-100 mb-3" onClick={onChangePrevPage}><i className="fas fa-chevron-left"></i> 内容の修正</button>
              <SubmitButton 
              text="予約申し込み"
              onClick={onSubmitOrder}
              isDisabledVal={
                isDisabled
                && simulationAmountData.loading
                && orderData.cource_id
                && orderData.cource_code
                && orderData.requestcource
                && orderData.requestpref_code
                && orderData.requestclinic_id
                && orderData.requestclinic
                && orderData.requestdt1
                && orderData.requestdt2
                && orderData.requestdt3 ? false : true
              }
            />
            </Fragment>
          :
            <SubmitButton 
              text="確認画面へ"
              onClick={onClickConfirmWithCal}
              isDisabledVal={
                isDisabled
                && orderData.cource_id
                && orderData.cource_code
                && orderData.requestcource
                && orderData.requestpref_code
                && orderData.requestclinic_id
                && orderData.requestclinic
                && orderData.requestdt1
                && orderData.requestdt2
                && orderData.requestdt3 ? false : true
              }
            />
          }
        </Fragment>
      )
    }
  }

  return (
    <>
      <ToastContainer />
      <h1 id="top">{page_title}{isConfirm && "（内容確認）"}</h1>
      { isConfirm && <ConfirmInfo /> }
      { SwitchFormDisplay() }
    </>
  );
});